export const containerNames = {
  backgroundContainer: 'backgroundContainer',
  characterContainer: 'characterContainer',
  fishPopupContainer: 'fishPopupContainer',
  transitionContainer: 'transitionContainer',
};
